import React from "react";
import styled from "styled-components";
import { Icon, Tooltip } from "@shopify/polaris";
import { InfoMinor } from "@shopify/polaris-icons";

const InfoButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.4rem;
    height: 2.4rem;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    cursor: help;

    &:focus-visible {
        outline: 2px solid #5c6ac4;
        outline-offset: 2px;
    }
`;

export default function UpdatedAtTooltip({ updatedAt }) {
    const content = updatedAt;
    return content ? (
        <div className="flex gap-1">
            <Tooltip content={"Last updated"} preferredPosition="above">
                <InfoButton
                    type="button"
                    aria-label={`Last updated: ${content}`}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                >
                    <Icon source={InfoMinor} color="subdued" />
                </InfoButton>
            </Tooltip>
            <p className="p-1">{content}</p>
        </div>
    ) : null;
}
